/* Istinja Bottle – tiroir panier : cross-sell packs + prix barré de référence (le prix comparé n'est pas renvoyé par la boutique) */
(function () {
  function addUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add.js'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ib-xsell-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-ib-xsell]');
    if (!box || btn.disabled) return;

    var counts = {};
    box.querySelectorAll('[data-ib-xsell-variant]').forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
    var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    if (!items.length) return;

    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = location.pathname; } catch (err) {}
    }
    var errEl = box.querySelector('[data-ib-xsell-error]');
    if (errEl) errEl.hidden = true;
    var spinner = btn.querySelector('.loading-overlay__spinner');
    btn.disabled = true; btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'error');
        if (drawer && typeof drawer.renderContents === 'function') {
          try { if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn); } catch (err) {}
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          return;
        }
        location.href = cartUrl();
      })
      .catch(function () {
        if (errEl) { errEl.textContent = (window.cartStrings && window.cartStrings.error) || 'Impossible d’ajouter cet article. Réessayez.'; errEl.hidden = false; }
        btn.disabled = false; btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ib-xsell-variant]');
    if (!sel) return;
    var box = sel.closest('[data-ib-xsell]');
    if (!box) return;
    var first = box.querySelector('[data-ib-xsell-variant]');
    var img = box.querySelector('[data-ib-xsell-img]');
    if (img && sel === first) {
      var o = sel.options[sel.selectedIndex];
      if (o && o.dataset.image) img.src = o.dataset.image;
    }
  });

  /* ---- Prix barré de référence dans le tiroir ---- */
  var applying = false, timer = null;
  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function setHtml(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function priceHtml(was, now) {
    if (was > now) return '<div class="cart-item__discounted-prices"><s class="cart-item__old-price product-option">' + fmt(was) + '</s><strong class="cart-item__final-price product-option">' + fmt(now) + '</strong></div>';
    return '<span class="product-option">' + fmt(now) + '</span>';
  }
  function fixPrices() {
    var refEl = document.querySelector('[data-ib-ref-price]');
    if (!refEl) return;
    var ref = parseInt(refEl.getAttribute('data-ib-ref-price'), 10) || 0;
    var pid = parseInt(refEl.getAttribute('data-ib-product-id'), 10) || 0;
    if (!ref) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      applying = true;
      var sub = 0;
      cart.items.forEach(function (item, i) {
        var isIb = item.product_id === pid;
        var unitRef = isIb ? Math.max(ref, item.original_price) : item.original_price;
        var lineRef = unitRef * item.quantity;
        sub += lineRef;
        var unitFinal = Math.round(item.final_line_price / item.quantity);
        setHtml(document.querySelector('.priceWrapper' + (i + 1)), priceHtml(unitRef, unitFinal));
        setHtml(document.querySelector('.linePriceWrapper' + (i + 1)), priceHtml(lineRef, item.final_line_price));
      });
      var savings = sub - cart.total_price;
      var subEl = document.querySelector('.drawer__subtotal--amount');
      var savEl = document.querySelector('.drawer__savings--amount');
      var totEl = document.querySelector('.drawer__total--amount');
      var subRow = document.querySelector('.totals.subtotal');
      var savRow = document.querySelector('.totals.savings');
      if (subEl) { if (subEl.textContent !== fmt(sub)) subEl.textContent = fmt(sub); }
      if (savEl) { var s = '-' + fmt(savings); if (savEl.textContent !== s) savEl.textContent = s; }
      if (totEl && totEl.textContent !== fmt(cart.total_price)) totEl.textContent = fmt(cart.total_price);
      var show = savings > 0 ? 'flex' : 'none';
      if (subRow && subRow.style.display !== show) subRow.style.display = show;
      if (savRow && savRow.style.display !== show) savRow.style.display = show;
      setTimeout(function () { applying = false; }, 50);
    }).catch(function () { applying = false; });
  }
  function schedule() { if (applying) return; clearTimeout(timer); timer = setTimeout(fixPrices, 200); }
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, characterData: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
